export default __webpack_public_path__ + "static/coffee4-b743d11933e5a6fce332fa14263c1b75.png";